import {
    type FilterData,
    type FilterKey,
} from '@itinerary/ItineraryModuleTypes';

export enum BundleStep {
    Residence = 'residence',
    Departure = 'departure',
    Return = 'return',
}

export interface BundleFiltersData {
    key: FilterKey;
    meta: FilterData;
}
